module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.title,
      "to": {
        name: 'feed',
        params: {
          identifier: _vm.moduleIdentifier,
          code: _vm.feed._id.$oid
        }
      },
      "withBody": false,
      "withFooter": false
    }
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.feed.status,
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.$t((_vm.moduleIdentifier + ".feed.statuses." + (_vm.feed.status) + ".label"))))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aa28cbd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shared/feed/Card.vue
// module id = 3010
// module chunks = 0